/**
 * features/leads/useLeads.ts
 * Live subscription to leads, newest first.
 */
import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { COLLECTIONS, type Lead } from '@/types';

export function useLeads() {
  const [leads, setLeads] = useState<Lead[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, COLLECTIONS.leads), orderBy('createdAt', 'desc'));
    return onSnapshot(
      q,
      (snap) => {
        setLeads(snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<Lead, 'id'>) })));
        setLoading(false);
      },
      () => setLoading(false),
    );
  }, []);

  return { leads, loading };
}
